import {resolveBackground} from '#core/utils/color-utils.js';

export function eventDisclaimerFactory(PALETTE) {
    return {
        EventDisclaimer: {
            expandableView: {
                initiallyExpanded: true,
                container: {
                    style: {
                        ...resolveBackground(PALETTE.EVENT_DISCLAIMER_CONTAINER_BG),
                        ...(PALETTE.EVENT_DISCLAIMER_WITH_SEPARATOR
                            ? {
                                  borderWidth: '1px 0 1px 0',
                                  borderStyle: 'solid',
                                  borderColor: PALETTE.EVENT_DISCLAIMER_SEPARATOR_COLOR,
                              }
                            : {
                                  borderWidth: 0,
                              }),
                        borderRadius: 8,
                        overflow: 'hidden',
                        margin: '8px 0',
                        _mobile_margin: '0 8px',
                        boxShadow: PALETTE.EVENT_DISCLAIMER_CONTAINER_BOX_SHADOW,
                    },
                },
                headerTextContainer: {
                    style: {
                        ...PALETTE.EVENT_DISCLAIMER_HEADER_TEXT,
                    },
                },
                rotation: {
                    image: {
                        style: {
                            fill: PALETTE.EVENT_DISCLAIMER_HEADER_ROTATION_ICON_COLOR,
                            width: '8px',
                            height: '8px',
                            minWidth: '8px',
                            minHeight: '8px',
                        },
                    },
                },
                contentContainer: {
                    style: {
                        base: {
                            padding: '8px 16px 16px 16px',
                        },
                    },
                },
            },
            contentText: {
                style: {
                    fontSize: 13,
                    whiteSpace: 'normal',
                    ...PALETTE.EVENT_DISCLAIMER_TEXT,
                },
            },
        },
    };
}
